<ngx-loading [show]="mainLoading" [config]="{primaryColour: '#2FA84F'}"></ngx-loading>
<div *ngIf="!mainLoading" class="row pt-1 justify-content-center">
    <div class="p-0 col-8 card card-outline-default shadow">
        <div class="card-header" style="background-color:#2FA84F">
            <div class="row my-3">
                <div class="col-md-6"><h3 class=" text-white"><a class="float-left a-link-color link-cursor" (click)="refreshPage()">GET INSTANT QUOTE</a></h3></div>
                <div class="col-md-6 ">
                    <a #quoteButton class="float-right a-link-color link-cursor" (click)="gotQuoteNo=false" [hidden]="!gotQuoteNo">I GOT A QUOTE</a>
                    <div class="search float-right" style="width:300px" [hidden]="gotQuoteNo">
                        <input #quoteInput style="display:inline-block;" type="text" class="form-control form-control-md" placeholder="Enter quote reference #" [(ngModel)]="quote_ref_no">
                        <button class="btn btn-md" *ngIf="quote_ref_no != '' && quote_ref_no != null"><i class="fa fa-arrow-circle-right" (click)="goToBooking('igotquote')"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <form [formGroup]="bookingForm"  (keydown.enter)="$event.preventDefault()">
            <div class="row col-12 m-6">
                <div class="col-6 text-left">
                    <div class="form-group">
                        <label for="input-1" class="font-weight-bold">From and To<span class="text-danger">*</span></label>
                        
                            <input
                              id="pickup-typeahead"
                              type="text"
                              placeholder="From (Pickup suburb or postcode only)" 
                              class="form-control"
                              [ngbTypeahead]="suburbSearch"
                              (selectItem)="onSuburbSelected($event, 'pickup')"
                              [inputFormatter]="formatter"
                              [resultFormatter]="formatter"
                              (blur)="onBlur('pickup')"
                              [ngClass]="{'is-valid': bookingForm.get('pickup_postcode_id').valid && fromLocation,
                              'is-invalid': (bookingForm.get('pickup_postcode_id').invalid || !fromLocation || !isLocationValid) && bookingForm.get('pickup_postcode_id').touched}"
                            />

                            <input
                              id="delivery-typeahead"
                              type="text"
                              placeholder="To (Delivery suburb or postcode only)" 
                              class="form-control mt-2"
                              [ngbTypeahead]="suburbSearch"
                              (selectItem)="onSuburbSelected($event, 'deliver')"
                              [inputFormatter]="formatter"
                              [resultFormatter]="formatter"
                              (blur)="onBlur('deliver')"
                              [ngClass]="{'is-valid': bookingForm.get('deliver_postcode_id').valid && toLocation,
                              'is-invalid': (bookingForm.get('deliver_postcode_id').invalid || !toLocation || !isLocationValid) && bookingForm.get('deliver_postcode_id').touched}"
                            />
                            <ng-container *ngIf="bookingForm.get('pickup_postcode_id').touched">
                                <small class="text-danger d-inline" *ngIf="!isLocationValid">From and To locations are the same!</small>
                                <small class="text-danger d-inline" *ngIf="bookingForm.get('pickup_postcode_id').errors?.required">Pickup Required.</small>
                                <small class="text-danger d-inline" *ngIf="!fromLocation && !bookingForm.get('pickup_postcode_id').errors?.required">Invalid Pickup Location!</small>
                            </ng-container>
                            
                            <br *ngIf="bookingForm.get('pickup_postcode_id').touched && bookingForm.get('deliver_postcode_id').touched">
                            
                            <ng-container *ngIf="bookingForm.get('deliver_postcode_id').touched">
                                <small class="text-danger d-inline" *ngIf="bookingForm.get('deliver_postcode_id').errors?.required">Delivery Required.</small>
                                <small class="text-danger d-inline" *ngIf="!toLocation && !bookingForm.get('deliver_postcode_id').errors?.required">Invalid Delivery Location!</small>
                            </ng-container>
                    </div>
                </div>

                <div class="col-6 text-left pl-0">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="input-1" class="font-weight-bold">Pickup Date<span class="text-danger">*</span></label>
                                <div class="input-group">
                                    <input class="form-control" 
                                        placeholder="yyyy-mm-dd" 
                                        name="dp" 
                                        formControlName="pickup_date" 
                                        ngbDatepicker 
                                        #p="ngbDatepicker" 
                                        [minDate]="minDate" 
                                        [ngClass]="{'is-valid':bookingForm.controls.pickup_date.valid, 'is-invalid':!bookingForm.controls.pickup_date.valid && bookingForm.controls.pickup_date.touched
                                    }">
                                    <div class="input-group-append" (click)="p.toggle()">
                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                    </div>
                                </div>
                                <ng-container *ngIf="bookingForm.controls.pickup_date.touched">
                                    <small class="text-danger" *ngIf="bookingForm.controls.pickup_date.errors?.required">Required.</small>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-6 d-flex align-self-center justify-content-start">
                            <div class="form-group">
                                <div class="clearfix">&nbsp;</div>
                                <span class="custom-control custom-checkbox">
                                    <input type="checkbox" id="checkboxUpgradePickup" formControlName="is_dg" class="custom-control-input">
                                    <label class="d-inline custom-control-label" for="checkboxUpgradePickup">Dangerous Goods 
                                        <a class="text-primary" href="javascript:void(0)" placement="right" ngbTooltip="Check this if your packagings include dangerous or hazardous materials"><i class="fa fa-info-circle pl-1"></i></a>
                                    </label>
                                </span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="row ml-3 mb-3">
                        <div class="custom-control custom-checkbox mr-5">
                            <input type="checkbox" class="custom-control-input" formControlName="has_tailgate" id="checkboxDefault">
                            <label class="custom-control-label" for="checkboxDefault">Tailgate</label>
                        </div>
                        <div class="custom-control custom-checkbox mr-5">
                            <input type="checkbox" class="custom-control-input" formControlName="is_hand_unload" id="checkboxPrimary">
                            <label class="custom-control-label" for="checkboxPrimary">Hand Unload</label>
                        </div>
                        <div class="custom-control custom-checkbox mr-5">
                            <input type="checkbox" class="custom-control-input" formControlName="is_trailer_split" id="checkboxSuccess">
                            <label class="custom-control-label" for="checkboxSuccess">Trailer Split</label>
                        </div>
                    </div>
                   
                </div>
                <!-- START PACKAGINGS GROUP-->
                
                <div class="col-12"><br/><hr><br/></div>
                <!-- <div class="clearfix"><hr></div> -->
                <div formArrayName="packagings">
                    <div *ngFor="let packaging of getPackagingControl(); let i=index" class="panel panel-default" >

                        <div [formGroupName]="i" class="col-md-12 pull-right pt-2" >
                            <div class="row">
                                <div class="col-2 pr-0">
                                    <label class="mb-0" for="input-2"><small class="font-weight-bold">Packaging<span class="text-danger">*</span></small></label>
                                    <select class="form-control" formControlName="packaging_type_id" (change)="onPackagingTypeChange($event, i)">
                                        <option disabled selected value="0">Select Packaging</option>
                                        <option *ngFor="let p of packagingTypes"  [attr.value]="p.id">{{p.name}}</option>
                                    </select>
                                </div>
                                <div class="col-1 pr-0">
                                    <label class="mb-0" for="input-2"><small class="font-weight-bold">Quantity<span class="text-danger">*</span></small></label>
                                    <input type="text" class="form-control" formControlName="quantity" (keyup)="assignTotalWeight(i)" min="0" 
                                     [ngClass]="{'is-valid':bookingForm.controls.packagings.controls[i].controls['quantity'].valid,
                                    'is-invalid':!bookingForm.controls.packagings.controls[i].controls['quantity'].valid &&
                                     bookingForm.controls.packagings.controls[i].controls['quantity'].touched
                                    }">
                                    <ng-container *ngIf="bookingForm.controls.packagings.controls[i].controls['quantity'].touched">
                                        <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['quantity'].errors?.required">Required</small>
                                        <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['quantity'].errors?.pattern">Invalid Input</small>

                                    </ng-container>
                                </div>

                                <div class="col-4 text-left">
                                    <label class="mb-0" for="length"><small class="font-weight-bold">Dimensions (L x W x H)<span class="text-danger">*</span></small></label>
                                    <div class="row">
                                        <div class="col-3 mr-0 pr-0">
                                            <div class="input-group">
                                                <input type="text" class="form-control" formControlName="length" placeholder="L"
                                                 [ngClass]="{'is-valid':bookingForm.controls.packagings.controls[i].controls['length'].valid,
                                                 'is-invalid':!bookingForm.controls.packagings.controls[i].controls['length'].valid &&
                                                  bookingForm.controls.packagings.controls[i].controls['length'].touched
                                                }">
                                            </div>
                                            <ng-container *ngIf="bookingForm.controls.packagings.controls[i].controls['length'].touched">
                                                <small class="text-danger d-block" *ngIf="bookingForm.controls.packagings.controls[i].controls['length'].errors?.required">Required</small>
                                                <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['length'].errors?.pattern">Invalid Input</small>
                                            </ng-container>
                                        </div>
                                        <div class="col-3 ml-0 mr-0 pl-0 pr-0">
                                            <div class="input-group">
                                                <input type="text" class="form-control" formControlName="width" placeholder="W"
                                                 [ngClass]="{'is-valid':bookingForm.controls.packagings.controls[i].controls['width'].valid,
                                                 'is-invalid':!bookingForm.controls.packagings.controls[i].controls['width'].valid &&
                                                 bookingForm.controls.packagings.controls[i].controls['width'].touched
                                                }">
                                            </div>
                                            <ng-container *ngIf="bookingForm.controls.packagings.controls[i].controls['width'].touched">
                                                <small class="text-danger d-block" *ngIf="bookingForm.controls.packagings.controls[i].controls['width'].errors?.required">Required</small>
                                                <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['width'].errors?.pattern">Invalid Input</small>
                                            </ng-container>
                                        </div>
                                        <div class="col-6 ml-0 pl-0 pr-3">
                                            <div class="input-group">
                                                <input type="text" class="form-control" formControlName="height" placeholder="H"
                                                 [ngClass]="{'is-valid':bookingForm.controls.packagings.controls[i].controls['height'].valid,
                                                 'is-invalid':!bookingForm.controls.packagings.controls[i].controls['height'].valid &&
                                                 bookingForm.controls.packagings.controls[i].controls['height'].touched
                                                }">
                                                <div class="input-group-append"><span class="input-group-text">cm</span></div>
                                            </div>
                                            <ng-container *ngIf="bookingForm.controls.packagings.controls[i].controls['height'].touched">
                                                <small class="text-danger d-block" *ngIf="bookingForm.controls.packagings.controls[i].controls['height'].errors?.required">Required</small>
                                                <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['height'].errors?.pattern">Invalid Input</small>
                                            </ng-container>    
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-2 ml-0 pl-0 pr-0">
                                    <label class="mb-0" for="input-1"><small class="font-weight-bold">Weight<span class="text-danger">*</span></small></label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" formControlName="weight" (keyup)="assignTotalWeight(i)"
                                         [ngClass]="{'is-valid':bookingForm.controls.packagings.controls[i].controls['weight'].valid,
                                         'is-invalid':!bookingForm.controls.packagings.controls[i].controls['weight'].valid &&
                                         bookingForm.controls.packagings.controls[i].controls['weight'].touched
                                        }">
                                        <div class="input-group-append"><span class="input-group-text">kg</span></div>
                                    </div>
                                    <ng-container *ngIf="bookingForm.controls.packagings.controls[i].controls['weight'].touched">
                                        <small class="text-danger d-block" *ngIf="bookingForm.controls.packagings.controls[i].controls['weight'].errors?.required">Required</small>
                                        <small class="text-danger" *ngIf="bookingForm.controls.packagings.controls[i].controls['weight'].errors?.pattern">Invalid Input</small>
                                    </ng-container>   
                                </div>

                                <div class="col-2">
                                    <label class="mb-0" for="input-2"><small class="font-weight-bold">Gross Weight</small></label>
                                    <div class="input-group">
                                        <input type="text" readonly class="form-control" formControlName="total_weight">
                                        <div class="input-group-prepend"><span class="input-group-text">kg</span></div> &nbsp;&nbsp;
                                        <a class="pt-2" [routerLink]="" (click)="removePackaging(i)" *ngIf="showPackagingRemoveIcon()"  placement="bottom" ngbTooltip="Delete item"><i
                                            class="fa fa-lg fa-trash-o"></i></a>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div> <!-- END NGFOR PACKAGINGS-->

                    <div class="row ml-3 text-left mt-2 pt-2">
                        <div class="col-12  pl-0 pt-2">
                            <button (click)="addPackaging()" type="button" 
                            class="btn btn-sm btn-outline-success w-100p"><i class="fa fa-plus-circle">&nbsp;</i>Add Item</button>
                            <small class="text-gray pl-2 align-self-center justify-content-start"> <i>Add items that are of different dimensions / type</i></small>
                        </div>
                    </div>
                    <div class="col-12"><br/></div>
                    <div class="row col-12">
                        <div class="col-md-12 ml-3 pt-2 pb-2 text-center" style="border:solid; border-color: lightgrey;border-width: 1px; border-radius: 3px;text-align: center;">
                            <span class="font-weight-bold text-gray">Total Weight: {{totalBookingWeight}} kg  | Total Chargeable Pallets: {{totalBookingPallets}}</span>
                        </div>
                    </div>

                    <div class="row ml-3 pt-3 pb-3 d-flex align-self-center justify-content-center"> 
                        <span class="text-center">
                            <button 
                                class="btn btn-primary" 
                                [disabled]="!isQuoteEnabled" 
                                (click)="getQuoteRate();" 
                                [hidden]="showQuote">
                                GET QUOTE
                            </button>
                        </span>
                    </div>
                </div><!-- END PACKAGINGS GROUP-->
            </div>
            </form>
            <ng-container *ngIf="showQuote">
                <hr style="border:0.5px dashed black">
                <div class="row m-3" *ngIf="serviceOptions$ | async as serviceOptions; else loading">
                    <form [formGroup]="selectedRateForm" class="col-md-12">
                        <h4 class="mb-0">RATE AND TIME QUOTATION</h4>
                        <p>Click the Book Now button on the option that meets your requirement to continue.</p>
                        <ng-container *ngFor="let option of serviceOptions; let i = index">
                            <div 
                                class="quote-card pl-3 pr-3 mt-3 card text-center" 
                                (mouseover)="bookQuoteHovered[i]=true" 
                                (mouseout)="bookQuoteHovered[i]=false"
                                [class.card-outline-default]="!bookQuoteHovered[i]" 
                                [class.card-outline-danger]="bookQuoteHovered[i]">
                                <div class="row pt-2 pb-2">
                                    <div class="col-md-3">
                                        <div class="text-left">
                                            <input type="radio"
                                                [id]="'option' + i" 
                                                formControlName="service_option" 
                                                [value]="option.type"
                                                (change)="onServiceOptionChange(option)">
                                            <label class="mb-0 pl-2 font-weight-bold"> {{ option.type | titlecase }} </label>
                                            <small class="pl-4 d-block">{{ option.description }} </small>
                                        </div>
                                    </div>
                                    <div class="col-md-4 text-left">
                                        <strong class="d-block">Route</strong>
                                        <small>
                                            {{ option.origin }} 
                                            <i class="fa fa-arrow-right" aria-hidden="true"></i> 
                                            {{ option.destination }}
                                        </small>
                                    </div>
                                    <div class="col-md-2 text-left align-self-center">
                                        <strong class="d-block">$ {{ option.price | number: '1.2-2': 'en-AU' }}</strong>
                                        <small *ngIf="isExGst()">(ex. GST)</small>
                                        <small *ngIf="!isExGst()">(inc. GST)</small>
                                    </div>
                                    <div class="col-md-3 text-left">
                                        <button type="submit" class="btn btn-sm btn-danger w-100p" (click)="goToBooking('booknow')">BOOK NOW</button>
                                        <small class="text-gray mt-0 align-bottom d-block"> Expiry: {{ option.expiryDate | date:'dd MMM yyyy' }} </small>
                                        <!-- (click)="saveQuote(option)" soon-->
                                    </div>
                                </div>
                            </div>                  
                        </ng-container>
                        
                        <div class="row" style="text-align:center">
                            <div class="col-md-12 mt-3 d-flex align-items-center justify-content-center">
                                <button 
                                    #searchButton 
                                    type="button" 
                                    class="btn btn-sm btn-danger" 
                                    (click)="this.emailQuote=false;" 
                                    [hidden]="!emailQuote">
                                        Email Me This Quote Now
                                </button>
                                <div class="search" style="width:300px" [hidden]="emailQuote">
                                    <input 
                                        #searchInput 
                                        style="display:inline-block;" 
                                        type="email" 
                                        class="form-control form-control-sm" 
                                        placeholder="Enter your email"
                                        [formControl]="selectedRateForm.get('email')"
                                        [ngClass]="{'is-invalid': selectedRateForm.get('email').invalid && selectedRateForm.get('email').touched}">
                                    
                                    <button 
                                        #searchEmail 
                                        (click)="saveQuote('emailquote')" 
                                        class="btn btn-sm"
                                        [disabled]="!selectedRateForm.get('service_option').value || selectedRateForm.get('email').invalid">
                                            <i #searchIcon class="fa fa-paper-plane" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-12 mt-0 text-center">
                                <small class="text-danger d-block" *ngIf="rateWarning">Select your rate first!</small>
                                <small class="text-danger d-block" *ngIf="selectedRateForm.get('email').errors?.required && selectedRateForm.get('email').touched">Email is required.</small>
                                <small class="text-danger d-block" *ngIf="selectedRateForm.get('email').errors?.email && selectedRateForm.get('email').touched">Please enter a valid email address.</small>
                                <small class="text-danger d-block" *ngIf="selectedRateForm.get('email').errors?.invalidEmailFormat && selectedRateForm.get('email').touched">Please enter a valid email address with a proper domain (e.g., .com, .org).</small>
                              </div>
                        </div >
                    </form>
                                
                </div>

                <ng-template #loading>
                    <p>Loading quote rates...</p>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>